import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Text as y } from "../../node_modules/@zillow/constellation-10/dist/components/text/text.esm.js";
const BlockQuoteContent = ({
  children
}) => /* @__PURE__ */ jsx(_StyledText, { textStyle: "body-lg", children });
var _StyledText = styled(y).withConfig({
  displayName: "BlockQuoteContent___StyledText",
  componentId: "sc-rox2hb-0"
})({
  textAlign: "center",
  display: "block",
  color: "inherit"
});
export {
  BlockQuoteContent as default
};
